<template>
  <card class="ticket-card" :class="{ 'ticket-card--compact': compact }">
    <div v-if="header" class="ticket-card-header">{{ header }}</div>

    <div v-if="ticketKey || ticketTitle || $slots.title" class="ticket-card-heading mb-3">
      <span v-if="ticketKey" class="ticket-key">{{ ticketKey }}</span>
      <slot name="title">
        <h4 v-if="ticketTitle" class="card-title mb-0 ticket-title">
          {{ ticketTitle }}<slot name="title-suffix" />
        </h4>
      </slot>
    </div>

    <slot />
  </card>
</template>

<script>
// Magenta-accented card used on ticket pages.
//   header       uppercase panel header ("Details") for the sidebar card
//   compact      tighter body padding so ticket-detail-field rows sit flush
//   ticketKey    small magenta key ("OTC-123") above the title
//   ticketTitle  read-only title; pages with an editable title use the
//                `title` slot instead and keep only the key here
export default {
  name: 'ticket-card',
  props: {
    header: { type: String, default: '' },
    compact: { type: Boolean, default: false },
    ticketKey: { type: String, default: '' },
    ticketTitle: { type: String, default: '' }
  }
}
</script>

<style scoped>
.ticket-card {
  border-left: 3px solid #e14eca !important;
}
.ticket-card--compact ::v-deep .card-body {
  padding: 14px 6px;
}
.ticket-card-header {
  padding: 4px 14px 12px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.8);
}
.ticket-card-heading {
  min-width: 0;
}
.ticket-key {
  font-size: 12px;
  letter-spacing: 0.5px;
  color: #e14eca;
}
.ticket-title {
  font-size: 20px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: -0.2px;
  padding: 4px 0;
}
.white-content .ticket-card-header {
  color: #344675;
}
.white-content .ticket-title {
  color: #344675;
}
</style>
